<div class="col-md-12">
    <!--<h2>BunnyCRM Drive</h2>-->
    <p>BunnyCRM Drive is BunnyCRM's file storage product — you can use it to manage your files online for
        personal use as well as for your business. Used personally, it's simply a place to store, organize,
        and access your files from anywhere. Used for business, files stay attached to the customer record
        they belong to instead of buried in email attachments, and can be referred to and reused elsewhere
        in BunnyCRM — in projects, campaigns, deals, and support tickets. No more re-uploading the same
        contract or asset into three different tools because none of them talk to each other.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Online File Storage:</strong> Upload, organize, and access your files from anywhere, for personal or business use.</li>
        <li><strong>Record-Linked Storage:</strong> Files attach directly to contacts, deals, tickets, or accounts.</li>
        <li><strong>Cross-Product Reuse:</strong> Files in Drive can be referenced and reused in BunnyCRM projects, marketing campaigns, sales deals, and support tickets instead of being re-uploaded each time.</li>
        <li><strong>Secure Cloud Storage:</strong> Documents are stored and served reliably at scale.</li>
        <li><strong>Access Control:</strong> File visibility follows the same team and role permissions as the rest of BunnyCRM.</li>
        <li><strong>Version History:</strong> Track changes to a document over time without losing earlier versions.</li>
    </ul>
</div>
